"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterReleaseNotes = exports.releaseNotes = void 0;
// User-visible changes, newest first within a day. Add an entry in the PR that makes a change
// visible to users or turns its flag on.
exports.releaseNotes = [
    {
        id: 'auto-closed-tickets-closed',
        date: '2026-10-27',
        title: 'Auto-closed tickets now show as Closed',
        body: 'Resolved tickets that Trackly closes for you after the resolution period now show as Closed instead of Cancelled. Their costs now count in the asset cost totals. Tickets that were closed this way earlier are being corrected, so their costs will appear in the totals too.',
        platforms: ['web', 'mobile'],
    },
    {
        id: 'asset-cost-summary-fac',
        date: '2026-10-26',
        title: 'Asset cost summary now includes facility repairs',
        body: "An asset's cost summary now adds up costs from both preventive maintenance and facility maintenance tickets that are resolved or closed. Each cost line shows which type it came from. On the web, the section now shows the right ticket count, and shows the empty message when an asset has no costs yet.",
        platforms: ['web', 'mobile'],
    },
    {
        id: 'approval-email-link',
        date: '2026-10-26',
        title: 'Approval emails now have a working link',
        body: 'The link in approval emails now opens the request in Trackly. Select "approve or reject" in the email to go straight to it. Reminder emails work the same way.',
        platforms: ['web', 'mobile'],
    },
    {
        id: 'approvals-back-to-dashboard',
        date: '2026-10-26',
        title: 'Go back to the dashboard from My Approvals',
        body: 'My Approvals now has a "Back to Dashboard" button at the top right of the page. Select it to return to your dashboard in one click, like on the other list pages.',
        platforms: ['web'],
    },
    {
        id: 'hst-access-provisioning',
        date: '2026-10-22',
        title: 'HST access can now be set up for you',
        body: 'When you ask for HST access for someone, Trackly now fills in their name, email, and HST user ID after you pick them. The HST user ID prefills with their email. Change it if their HST login is different. After the request is approved, Trackly sets up the HST access for you. The ticket shows the result: Pending, Provisioned, Provisioning failed, or Manual provisioning needed. If it did not work, the ticket tells you why, so you can fix it or set up the access by hand.',
        platforms: ['web', 'mobile'],
        flag: 'HstProvisioning',
    },
    {
        id: 'whats-new',
        date: '2026-10-19',
        title: "See what's new in Trackly",
        body: 'You can now see recent changes to Trackly in one place. On the web, select the "What\'s new" button (megaphone icon) at the top right of the page. On the mobile app, open the notice on the Home screen. A badge or notice shows when there is something you have not seen yet.',
        platforms: ['web', 'mobile'],
        flag: 'WhatsNew',
    },
];
// Fails closed like `useFeatureFlag`: a flagged note needs the flag to be exactly `true`.
function filterReleaseNotes(notes, platform, flags) {
    return notes
        .filter((n) => n.platforms.includes(platform) && (n.flag === undefined || (flags === null || flags === void 0 ? void 0 : flags[n.flag]) === true))
        .map((n, index) => ({ n, index }))
        .sort((a, b) => b.n.date.localeCompare(a.n.date) || a.index - b.index)
        .map(({ n }) => n);
}
exports.filterReleaseNotes = filterReleaseNotes;
